
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/win-the-wedding-of-your-dreams",
      function () {
        return require("private-next-pages/landing/win-the-wedding-of-your-dreams.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/win-the-wedding-of-your-dreams"])
      });
    }
  